import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-bar.html',
  styleUrls: ['./loading-bar.scss']
})
export class LoadingBarComponent {
  active = input<boolean>(false);
  progress = input<number>(0);
}
